import React from "react";

type SortIconProps = {
  className?: string;
};

export default function SortIcon({ className }: SortIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path d="M12 15.0004L7 10.0254H17L12 15.0004Z" fill="currentColor" />
    </svg>
  );
}
